

export const getDateSetter = (value) => {
    try {
      return new Date(value).toLocaleString('en-GB', { timeZone: 'UTC' })
    }catch(err){
      return value
    }
  }

export const getNow = () => {
  const dt = new Date()
  const updatedt = dt.toISOString().substring(0,10) + "T" + dt.getHours().toString().padStart(2,'0') + ":" + dt.getMinutes().toString().padStart(2,'0') + ":" + dt.getSeconds().toString().padStart(2,'0') + "." + dt.getMilliseconds() + "Z";
  return updatedt;
}

export const getNowMySQL = () => {
  return new Date().toISOString().replace("T"," ").substring(0,19)
}

export function GetCourtNo(text) {
  var p;
  if(typeof text === "undefined" || text === null || text.trim() === "")
      return "";
  let courtno = "";
  let matchpats = [
      /(CR|BR)-(\d{4})-(\d{6})/,
      /(CR|BR)-(\d{4})-([A-Z]{3})-(\d{6})/,
      /(COURT NO )(\d{4,6})( OF )(\d{4})/,
      /(COURT NO. )(\d{4,6})( OF )(\d{4})/,
      /(NO\. )(\d{4,6})( OF )(\d{4})/,
      /(NO )(\d{4,6})( OF )(\d{4})/,
  ]                    
  for(let il=0; il<matchpats.length; il++) {
      p = text.trim().toUpperCase().match(matchpats[il])
      if(p!==null && Array.isArray(p) && p.length > 0){
          courtno = p[0];
          if(il>=2)
              courtno = `CR-${p[4]}-${p[2].padStart(6,'0')}`
          break;
      }  
  }
  return courtno;
}

export function getCompanyNumberFromFullPets(fullpettext) {
  // Regular Expressions to find  Company Number from Full Petition Texts
  let matchcn = /(COMPANY NUMBER )((AC|ZC|FC|GE|LP|OC|SE|SA|SZ|SF|GS|SL|SO|SC|ES|NA|NZ|NF|GN|NL|NC|R0|NI|EN|\d{2}|SG|FE)\d{5}(\d|C|R))|((RS|SO)\d{3}(\d{3}|\d{2}[WSRCZF]|\d(FI|RS|SA|IP|US|EN|AS)|CUS))|((NI|SL)\d{5}[\dA])|(OC(([\dP]{5}[CWERTB])|([\dP]{4}(OC|CU))))/

  let company_number = "";
  let p = fullpettext.toUpperCase().trim().match(matchcn);
  if(typeof p !== 'undefined' && p!==null && p.length > 0 )
      company_number =  p[2];
  return company_number;
}

